import { InjectionToken } from '@angular/core';

export const BOTTOM_SHEET_DATA = new InjectionToken<any>('BOTTOM_SHEET_DATA');
